import { useEffect } from 'react';
export default (ref, handleClickOutside, active) => {
    const handleClick = (e) => {
        if (!active)
            return;
        if (ref.current && !ref.current.contains(e.target)) {
            handleClickOutside();
        }
    };
    useEffect(() => {
        document.addEventListener('click', handleClick);
        return () => {
            document.removeEventListener('click', handleClick);
        };
    });
};
